module.exports = __webpack_public_path__ + "static/media/ic-pontos.abbc551d.svg";